import { useEffect } from "react";
import { createFileRoute, notFound } from "@tanstack/react-router";
import { PortalPage } from "@/components/portal/PortalPage";
import { MiembroPublicoHero } from "@/components/site/MiembroPublicoHero";
import { buildSeo } from "@/lib/seo";
import { getSeleccionPublica, registrarVistaSeleccion } from "@/lib/selecciones.functions";

/** Página temporal con los locales que un agente ha escogido para un cliente. */
export const Route = createFileRoute("/seleccion/$token")({
  loader: async ({ params }) => {
    if (!/^[A-Za-z0-9_-]{8,40}$/.test(params.token)) throw notFound();
    const sel = await getSeleccionPublica({ data: { token: params.token } });
    if (!sel) throw notFound();
    return sel;
  },
  head: ({ loaderData, params }) =>
    buildSeo({
      title: loaderData
        ? `Locales escogidos por ${loaderData.agente.nombre} | Bizaclia`
        : "Selección no encontrada | Bizaclia",
      description: "Selección personal de locales en Bizaclia.",
      path: `/seleccion/${params.token}`,
      noindex: true,
    }),
  component: SeleccionPage,
  notFoundComponent: () => (
    <main className="flex min-h-[60vh] items-center justify-center px-4 py-16">
      <div className="max-w-lg text-center">
        <h1 className="font-display text-3xl font-bold tracking-tight">Selección no encontrada</h1>
        <p className="mt-4 text-muted-foreground">Revisa el enlace o pide a tu agente que te lo vuelva a enviar.</p>
      </div>
    </main>
  ),
});

function SeleccionPage() {
  const sel = Route.useLoaderData();
  const { token } = Route.useParams();

  useEffect(() => {
    void registrarVistaSeleccion({ data: { token } }).catch(() => {});
  }, [token]);

  return (
    <>
      <MiembroPublicoHero miembro={sel.agente} />

      <section className="container mx-auto max-w-7xl px-4 sm:px-6 pt-10 pb-4">
        <h2 className="font-display font-semibold text-2xl sm:text-3xl tracking-tight">
          {sel.clienteNombre ? `${sel.clienteNombre}, he escogido estos locales para ti` : "He escogido estos locales para ti"}
        </h2>
        {sel.mensaje && (
          <p className="mt-3 max-w-3xl whitespace-pre-line text-muted-foreground">{sel.mensaje}</p>
        )}
        {sel.caducada && (
          <p className="mt-4 rounded-lg border border-dashed bg-muted/30 p-4 text-sm text-muted-foreground">
            Esta selección ha caducado. Escribe a {sel.agente.nombre} si quieres que te envíe opciones actualizadas.
          </p>
        )}
      </section>

      {!sel.caducada && (
        <PortalPage mode="seleccion" seleccionIds={sel.anuncioIds} seleccionToken={token} segments={[]} />
      )}
    </>
  );
}
